import { ButtonBadge, ButtonWrapper } from './Button.styles'

interface ButtonProps {
  children: React.ReactNode
  type?: 'button' | 'submit' | 'reset'
  block?: boolean
  variant?: 'primary' | 'secondary' | 'tertiary' | 'red' | 'link' | 'light'
  onClick?: () => void
  badge?: number
  size?: 'sm' | 'lg'
  disabled?: boolean
}

const Button = ({ children, type = 'button', block, variant = 'primary', onClick, badge, size, disabled }: ButtonProps) => {
  return (
    <ButtonWrapper type={type} block={block} variant={variant} size={size} onClick={onClick} disabled={disabled}>
      {children}
      {badge && <ButtonBadge>{badge}</ButtonBadge>}
    </ButtonWrapper>
  )
}

export default Button
